module.exports = __webpack_public_path__ + "static/media/brain-outline.bf58741f.svg";